import {AxiosError, HttpStatusCode} from 'axios';
import {ROUTES} from '@/utils/constants/routesConstants';
import {logger} from '@/helpers/logger';

export const onUnauthorisedError = async () => {
  logger.warn('User unauthorized. Redirecting...');
};

export const handleNetworkErrors = async (error) => {
  const {code, response, message} = error;
  const status = response?.status;

  if (code === AxiosError.ERR_CANCELED) {
    return Promise.reject(
      new Error(message || 'Request was canceled', {
        cause: response?.data?.message
      })
    );
  }

  if (status === HttpStatusCode.Forbidden) {
    window.location.href = ROUTES.ERROR_403;
  } else if (
    status === HttpStatusCode.Unauthorized ||
    code === AxiosError.ERR_NETWORK
  ) {
    try {
      await onUnauthorisedError();
    } catch (signOutError) {
      logger.error('onUnauthorisedError::ERROR', signOutError);
    }
  }
  const customError = new Error(message || 'An error occurred', {
    cause: response?.data?.message
  });
  customError.response = response;
  customError.status = status;
  customError.data = response?.data;
  return Promise.reject(customError);
};

// Attach the interceptor to an Axios instance
export const attachErrorInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response, // Pass successful responses through
    handleNetworkErrors
  );
};
